import { createStore } from 'react-sweet-state';

import {
  APPLICATION_BAR_HEIGHT,
  BANNER_PERFORMANCE_PREDICTIONS_HEIGHT,
  TEXT_DETAILS_PANEL_TAB,
} from 'src/data/ui';
import { getQueryParams } from 'src/lib/browser';
import * as ls from 'src/lib/localData';

const INITIAL_STATE = {
  appbarHeight: APPLICATION_BAR_HEIGHT,
  fullNavbarHeight: APPLICATION_BAR_HEIGHT,
  measuredNotificationsHeight: 0,
  notificationsHeight: 0,
  bannerHeight: 0,

  appbarVisible: true,

  welcomePopupWasShown: false,
  globalPopupVisibleCount: 0,
  localPopupVisibleCount: 0,

  showWebinarBanner: false,
  textDetailsPanelTab: TEXT_DETAILS_PANEL_TAB.performance,
  showPerformancePredictionsBanner: false,
};

const calculateAppbarHeight =
  () =>
  ({ getState, setState }) => {
    const { measuredNotificationsHeight, showPerformancePredictionsBanner } = getState();

    const notificationsHeight = measuredNotificationsHeight;
    const bannerHeight = showPerformancePredictionsBanner
      ? BANNER_PERFORMANCE_PREDICTIONS_HEIGHT
      : 0;
    const fullNavbarHeight = APPLICATION_BAR_HEIGHT + notificationsHeight + bannerHeight;

    setState({ fullNavbarHeight, notificationsHeight, bannerHeight });
  };

export const ACTIONS = {
  init:
    () =>
    ({ setState }) => {
      const params = getQueryParams();

      setState({
        appbarVisible: params['appbar-visible'] !== 'false',
        textDetailsPanelTab: TEXT_DETAILS_PANEL_TAB.clamp(ls.textDetailsPanelTab.read()),
      });
    },

  setNotificationsHeight:
    (height) =>
    ({ setState, dispatch }) => {
      setState({ measuredNotificationsHeight: height });
      dispatch(calculateAppbarHeight());
    },

  markWelcomePopupAsShown:
    () =>
    ({ setState }) => {
      setState({ welcomePopupWasShown: true });
    },

  wasWelcomePopupShown:
    () =>
    ({ getState }) => {
      return getState().welcomePopupWasShown;
    },

  setShowWebinarBanner:
    (showWebinarBanner) =>
    ({ setState }) => {
      setState({ showWebinarBanner });
    },

  setShowPerformancePredictionsBanner:
    (value) =>
    ({ setState, dispatch }) => {
      setState({ showPerformancePredictionsBanner: value });
      dispatch(calculateAppbarHeight());
    },

  setGlobalPopupVisibleCount:
    (value) =>
    ({ setState }) => {
      setState({ globalPopupVisibleCount: value });
    },
  increaseLocalPopupVisibleCount:
    () =>
    ({ getState, setState }) => {
      const { localPopupVisibleCount } = getState();
      setState({ localPopupVisibleCount: localPopupVisibleCount + 1 });
    },
  decreaseLocalPopupVisibleCount:
    () =>
    ({ getState, setState }) => {
      const { localPopupVisibleCount } = getState();
      setState({ localPopupVisibleCount: Math.max(localPopupVisibleCount - 1, 0) });
    },

  setTextDetailsPanelTab:
    (newTab) =>
    ({ setState }) => {
      setState({ textDetailsPanelTab: newTab });
      // Store selected tab for future sessions
      ls.textDetailsPanelTab.write(newTab);
    },
  getTextDetailsPanelTab:
    () =>
    ({ getState }) => {
      return getState().textDetailsPanelTab;
    },
};

export const UiStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'global-ui',
});
